// Client-safe list of service categories for the public directory. Providers
// pick theirs in Settings; customers filter by them on /services.
export const SERVICE_CATEGORIES = [
  "Painter",
  "Electrician",
  "Plumber",
  "Carpenter",
  "Gardener",
  "Cleaning",
  "Moving",
  "Roofing",
  "Heating & Climate",
  "IT & Software",
  "Web & Design",
  "Marketing",
  "Photography",
  "Legal",
  "Accounting",
  "Consulting",
] as const;

export const SERVICE_COMMISSION_RATE = 0.1; // RTN keeps 10% of every paid job
